import moment from "moment";
import * as React from "react";
import useWindowSize from "../../../../../hooks/useWindowSize";

export interface ScheduleTabsOptionsProps {
  index: number;
  date: string;
}

export interface ScheduleTabsProps {
  activeIndex?: number;
  options: ScheduleTabsOptionsProps[];
  onChangeTab: (index: number) => void;
}

const ScheduleTabs: React.FC<ScheduleTabsProps> = ({
  activeIndex = 0,
  options = [],
  onChangeTab,
}) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const handleChangeTab = (event: React.SyntheticEvent<HTMLDivElement>) => {
    const { index } = event?.currentTarget?.dataset;

    onChangeTab?.(Number(index ?? 0));
  };

  const styleClassname = React.useMemo(() => {
    if (isMobileView) {
      return {
        border: "3px solid #274364",
        container: "flex w-[100%] rounded-[16px] bg-[#1F2D3D]",
        innerContainer: "w-[33.3%] h-[100%] px-[18px] py-[12px] cursor-pointer",
        textDayName: "text-[11px] p-0 m-0 text-white leading-[13px]",
        textDate: "text-[32px] p-0 m-0 text-white leading-[40px]",
        textMonth: "text-[11px] p-0 m-0 text-white leading-[13px]",
        card: "flex flex-col items-center rounded-[8px] p-[8px] gap-[14px]",
      };
    }

    return {
      border: "5px solid #274364",
      container: "flex w-[100%] rounded-[24px] bg-[#1F2D3D]",
      innerContainer: "w-[33.3%] h-[100%] px-[32px] py-[24px] cursor-pointer",
      textDayName: "text-[28px] p-0 m-0 text-white leading-[37px]",
      textDate: "text-[50px] p-0 m-0 text-white leading-[50px]",
      textMonth: "text-[28px] p-0 m-0 text-white leading-[37px]",
      card: "flex flex-col items-center rounded-[20px] p-[20px] gap-[24px]",
    };
  }, [isMobileView]);

  return (
    <div style={{ border: styleClassname?.border }} className={styleClassname?.container}>
      {options?.map((opt, idx) => {
        const isActiveIndex = activeIndex === idx;
        const bgColor = isActiveIndex ? "bg-[#0397C9]" : "bg-[#1F2D3D]";

        const dayName = moment(opt?.date)?.format("dddd");
        const date = moment(opt?.date)?.format("D");
        const month = moment(opt?.date)?.format("MMMM");

        const boldText = isActiveIndex ? "font-bold" : "font-normal";

        return (
          <div
            onClick={handleChangeTab}
            data-index={opt?.index}
            className={styleClassname?.innerContainer}
          >
            <div className={`${styleClassname?.card} ${bgColor}`}>
              <h1 className={`${styleClassname?.textDayName} ${boldText}`}>{dayName}</h1>
              <h1 className={`${styleClassname?.textDate} font-bold`}>{date}</h1>
              <h1 className={`${styleClassname?.textMonth} ${boldText}`}>{month}</h1>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScheduleTabs;
